var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_140200",
    "data-name": "Group 140200",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#de1515"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cheque",
    transform: "translate(7.061 7.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140204",
    "data-name": "Group 140204",
    transform: "translate(6.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34258",
    "data-name": "Path 34258",
    d: "M34.677,12.613h-3.37a.306.306,0,0,1,0-.613h3.37a.306.306,0,1,1,0,.613Z",
    transform: "translate(-31 -12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140205",
    "data-name": "Group 140205",
    transform: "translate(6.128 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34259",
    "data-name": "Path 34259",
    d: "M31.306,18.451A.306.306,0,0,1,31,18.145V16.306a.306.306,0,1,1,.613,0v1.838A.306.306,0,0,1,31.306,18.451Z",
    transform: "translate(-31 -16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140206",
    "data-name": "Group 140206",
    transform: "translate(9.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34260",
    "data-name": "Path 34260",
    d: "M42.919,13.226a.306.306,0,0,1-.306-.306.307.307,0,0,0-.306-.306.306.306,0,1,1,0-.613.92.92,0,0,1,.919.919A.306.306,0,0,1,42.919,13.226Z",
    transform: "translate(-42 -12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140207",
    "data-name": "Group 140207",
    transform: "translate(10.112 0.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34261",
    "data-name": "Path 34261",
    d: "M44.306,17.064A.306.306,0,0,1,44,16.758V14.306a.306.306,0,0,1,.613,0v2.451A.306.306,0,0,1,44.306,17.064Z",
    transform: "translate(-44 -14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140208",
    "data-name": "Group 140208",
    transform: "translate(1.677 3.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34262",
    "data-name": "Path 34262",
    d: "M26.438,22.613H16.777a.306.306,0,1,1,0-.613h9.661a.306.306,0,0,1,0,.613Z",
    transform: "translate(-16.471 -22)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140209",
    "data-name": "Group 140209",
    transform: "translate(1.677 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34263",
    "data-name": "Path 34263",
    d: "M26.438,16.613H16.777a.306.306,0,0,1,0-.613h9.661a.306.306,0,0,1,0,.613Z",
    transform: "translate(-16.471 -16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140210",
    "data-name": "Group 140210",
    transform: "translate(0 2.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34264",
    "data-name": "Path 34264",
    d: "M12.982,20.532a.3.3,0,0,1-.147-.038l-1.676-.919a.306.306,0,1,1,.295-.537l1.676.919a.306.306,0,0,1-.148.575Z",
    transform: "translate(-10.999 -19)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140211",
    "data-name": "Group 140211",
    transform: "translate(0 1.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34265",
    "data-name": "Path 34265",
    d: "M11.306,17.531a.306.306,0,0,1-.148-.575l1.676-.919a.306.306,0,1,1,.295.537l-1.676.919A.3.3,0,0,1,11.306,17.531Z",
    transform: "translate(-10.999 -15.999)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140212",
    "data-name": "Group 140212",
    transform: "translate(11.337 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34266",
    "data-name": "Path 34266",
    d: "M48.306,18.451a.306.306,0,1,1,0-.613.614.614,0,0,0,0-1.226.306.306,0,0,1,0-.613,1.226,1.226,0,0,1,0,2.451Z",
    transform: "translate(-48 -16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140213",
    "data-name": "Group 140213",
    transform: "translate(0 5.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34267",
    "data-name": "Path 34267",
    d: "M11.306,35.515A.306.306,0,0,1,11,35.209v-4.9a.306.306,0,1,1,.613,0v4.9A.306.306,0,0,1,11.306,35.515Z",
    transform: "translate(-11 -30)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140214",
    "data-name": "Group 140214",
    transform: "translate(12.256 5.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34268",
    "data-name": "Path 34268",
    d: "M51.306,35.515A.306.306,0,0,1,51,35.209v-4.9a.306.306,0,1,1,.613,0v4.9A.306.306,0,0,1,51.306,35.515Z",
    transform: "translate(-51 -30)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140215",
    "data-name": "Group 140215",
    transform: "translate(11.031 10.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34269",
    "data-name": "Path 34269",
    d: "M47.306,47.838a.306.306,0,0,1,0-.613.92.92,0,0,0,.919-.919.306.306,0,1,1,.613,0A1.534,1.534,0,0,1,47.306,47.838Z",
    transform: "translate(-47 -46)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140216",
    "data-name": "Group 140216",
    transform: "translate(1.226 11.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34270",
    "data-name": "Path 34270",
    d: "M25.111,50.613H15.306a.306.306,0,1,1,0-.613h9.805a.306.306,0,0,1,0,.613Z",
    transform: "translate(-15 -50)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140217",
    "data-name": "Group 140217",
    transform: "translate(0 10.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34271",
    "data-name": "Path 34271",
    d: "M12.532,47.838A1.534,1.534,0,0,1,11,46.306a.306.306,0,1,1,.613,0,.92.92,0,0,0,.919.919.306.306,0,0,1,0,.613Z",
    transform: "translate(-11 -46)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140218",
    "data-name": "Group 140218",
    transform: "translate(5.515 9.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34272",
    "data-name": "Path 34272",
    d: "M34.209,44.613h-4.9a.306.306,0,0,1,0-.613h4.9a.306.306,0,1,1,0,.613Z",
    transform: "translate(-29 -44)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140219",
    "data-name": "Group 140219",
    transform: "translate(5.515 7.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34273",
    "data-name": "Path 34273",
    d: "M34.209,38.613h-4.9a.306.306,0,1,1,0-.613h4.9a.306.306,0,1,1,0,.613Z",
    transform: "translate(-29 -38)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140220",
    "data-name": "Group 140220",
    transform: "translate(5.515 6.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34274",
    "data-name": "Path 34274",
    d: "M34.209,32.613h-4.9a.306.306,0,0,1,0-.613h4.9a.306.306,0,1,1,0,.613Z",
    transform: "translate(-29 -32)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140230",
    "data-name": "Group 140230",
    transform: "translate(0 4.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34284",
    "data-name": "Path 34284",
    d: "M11.306,27.838A.306.306,0,0,1,11,27.532,1.534,1.534,0,0,1,12.532,26a.306.306,0,0,1,0,.613.92.92,0,0,0-.919.919A.306.306,0,0,1,11.306,27.838Z",
    transform: "translate(-11 -26)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140231",
    "data-name": "Group 140231",
    transform: "translate(1.226 4.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34285",
    "data-name": "Path 34285",
    d: "M25.111,26.613H15.306a.306.306,0,0,1,0-.613h9.805a.306.306,0,0,1,0,.613Z",
    transform: "translate(-15 -26)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140232",
    "data-name": "Group 140232",
    transform: "translate(11.031 4.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34286",
    "data-name": "Path 34286",
    d: "M48.532,27.838a.306.306,0,0,1-.306-.306.92.92,0,0,0-.919-.919.306.306,0,0,1,0-.613,1.534,1.534,0,0,1,1.532,1.532A.306.306,0,0,1,48.532,27.838Z",
    transform: "translate(-47 -26)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140235",
    "data-name": "Group 140235",
    transform: "translate(1.685 5.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140234",
    "data-name": "Group 140234",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3634",
    "data-name": "Path 3634",
    d: "M136.378,33.8a.231.231,0,0,1,.145.053c.29.231.747.637,1.189,1.03.37.329.72.64.908.79a.244.244,0,0,1,0,.377l-2.059,1.865a.234.234,0,0,1-.149.054.243.243,0,0,1-.186-.088.239.239,0,0,1-.051-.2h0l.358-1.785a.106.106,0,0,0,0-.036l-.375-1.786a.234.234,0,0,1,.047-.194A.218.218,0,0,1,136.378,33.8Zm.1,4.008,2.059-1.864a.105.105,0,0,0,.039-.083.1.1,0,0,0-.039-.081c-.191-.152-.542-.464-.914-.795-.441-.391-.9-.8-1.184-1.025a.1.1,0,0,0-.061-.023.084.084,0,0,0-.065.031.1.1,0,0,0-.018.081l.375,1.786a.245.245,0,0,1,0,.087h0l-.358,1.785a.1.1,0,0,0,.021.084.107.107,0,0,0,.082.039A.1.1,0,0,0,136.478,37.805Z",
    transform: "translate(-136.005 -33.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3634_-_Outline",
    "data-name": "Path 3634 - Outline",
    d: "M136.031,33.3a.383.383,0,0,1,.24.086c.293.234.752.641,1.2,1.035.369.328.718.638.9.785a.4.4,0,0,1,.008.612l-2.057,1.863-.006.005a.385.385,0,0,1-.245.088.4.4,0,0,1-.3-.144.39.39,0,0,1-.083-.322v0l.355-1.772-.372-1.773v0a.385.385,0,0,1,.08-.319A.371.371,0,0,1,136.031,33.3Zm2.019,2.217c-.2-.164-.529-.456-.876-.764-.374-.332-.758-.674-1.04-.908l.338,1.611v0a.4.4,0,0,1,0,.141v0l-.328,1.636Z",
    transform: "translate(-135.658 -33.297)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938",
    transform: "translate(0.018 1.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3634-2",
    "data-name": "Path 3634",
    d: "M138.276,56.525a4.291,4.291,0,0,1,.568.009l.042.013.005.044a.177.177,0,0,1-.015.108l0,0a.26.26,0,0,1-.089.118l-2.041,1.846a.234.234,0,0,1-.149.054.243.243,0,0,1-.186-.088.239.239,0,0,1-.051-.2h0l.358-1.785a.107.107,0,0,0,0-.037l-.014-.08h.08C136.793,56.532,137.678,56.525,138.276,56.525Zm.468.139c-.069,0-.2,0-.468,0-.5,0-1.2,0-1.423.006v.006h0l-.358,1.785a.1.1,0,0,0,.021.085.108.108,0,0,0,.082.039.1.1,0,0,0,.063-.023l2.047-1.852,0,0A.122.122,0,0,0,138.744,56.665Z",
    transform: "translate(-136.203 -56.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3634_-_Outline-2",
    "data-name": "Path 3634 - Outline",
    d: "M137.929,56.025a2.884,2.884,0,0,1,.614.016l.042.013a.153.153,0,0,1,.107.128l.005.044a.329.329,0,0,1-.025.184v0a.418.418,0,0,1-.135.18l-2.034,1.84-.006.005a.385.385,0,0,1-.245.088.4.4,0,0,1-.3-.144.39.39,0,0,1-.083-.322v0l.355-1.773-.013-.072a.153.153,0,0,1,.15-.18h.08C136.445,56.032,137.326,56.025,137.929,56.025Zm.086.443h-.086c-.428,0-1.006,0-1.3,0l-.3,1.522Z",
    transform: "translate(-135.856 -56.025)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.e67383b64598593fccbcb659d9ff306c.svg";
export { ForwardRef as ReactComponent };